import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import $ from "jquery";

import {featureInterface} from "../../../../interfaces/featureInterface";
import {
  setLookActiveCategory,
  setLookActiveFeature,
  setLookOpened,
} from "../../../../actions/lookFunctions";
import LookCanvasContext from "../../lookCanvasContext";
import WithZoomToFeature from "../../hocs/withZoomToFeature";
import {setShopLastPageVisited, setShopPageLeaved, setShopPageOpened} from "../../../../actions/shopFunctions";
import {getCurrentLayout} from "../../../appLayout";
import {applyNewPreset} from "../../lookNavigation/lookNavigationFunctions";
import {loaderDisable, loaderEnable} from "../../../ui/loaderView";
import {updateCanvasCount} from "../../../../actions/actionFunctions";
import {navFeatureCLick} from "../../lookNavigation/lookFunctions";
import {enableRelatedFeature} from "../../lookNavigation/lookFunctions2";
import {checkIfLookFeaturesReceived} from "../../../../api/look-api";


const WithShopFeatureVisualizeClick = (props) => {

  const {feature, children, setShopPageOpened, setLookActiveCategory, isMobile, setShopLastPageVisited, location,
    setShopPageLeaved, bvPresets, loadedPresets, updateCanvasCount, isDisabled} = props;

  const visualizeButtonClick = async (zoomToFeatureGroup) => {
    if (isDisabled) {
      return
    }
    console.log("visualize feature", feature);
    let featureToClick = feature;

    if (Array.isArray(featureToClick.metaData["RoomLayout"]) && featureToClick.metaData["RoomLayout"].length) {

      let newLayoutType = +((featureToClick.metaData["RoomLayout"][0]).replace("Layout", ""));
      const layout = getCurrentLayout();
      if (layout.initialized && (newLayoutType !== layout.type)) {
        const featureFromCurrentLayout = layout.getFeatureBySku(feature.dbFeature.sharedFeatureName,
          feature.partId, false, true);
        if (featureFromCurrentLayout && featureFromCurrentLayout.metaData["RoomLayout"]) {
          featureToClick = featureFromCurrentLayout;
          newLayoutType = +((featureFromCurrentLayout.metaData["RoomLayout"][0]).replace("Layout", ""));
          console.log("visualize feature replaced", featureFromCurrentLayout);
        }
      }
      if (newLayoutType !== layout.type) {
        const newPreset = bvPresets.find(bvPreset => bvPreset.layout_type === newLayoutType);
        loaderEnable();
        await checkIfLookFeaturesReceived(featureToClick.getParent()); // this receives sinks to apply faucet
        if (newPreset) {
          await applyNewPreset(newPreset, loadedPresets);
        } else {
          const layout = getCurrentLayout();
          await layout.selectLayout(newLayoutType);
        }
        navFeatureCLick(featureToClick, true, true, true);
        enableRelatedFeature(featureToClick, () => {}, 0);
        updateCanvasCount();
        await new Promise(resolve => setTimeout(resolve, 1000)); // this fixes scene jump
        loaderDisable();
      }
    }
    const shopDiv = document.querySelector(".shop");
    if (shopDiv) {
      shopDiv.classList.add("shop--closing");
    }
    setShopLastPageVisited(location.pathname);
    $(".overlay--white2").fadeOut(800, () => {
      zoomToFeatureGroup(featureToClick.partId, featureToClick);
      setShopPageOpened("");
      setShopPageLeaved(true);
      if (!isMobile) {
        setTimeout(() => {
          setLookActiveCategory(featureToClick.partId);
        }, 300)
      }
    });
  }

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => children(() => visualizeButtonClick(zoomToFeatureGroup))}
        </WithZoomToFeature>
      )}
    </LookCanvasContext.Consumer>
  )
};

WithShopFeatureVisualizeClick.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired,
  isDisabled: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {bvPresets, loadedPresets} = store.bathroomVisualizerState;

  return {
    isMobile,
    bvPresets,
    loadedPresets,
  };
};

const mapDispatchToProps = {
  setShopPageOpened,
  setLookOpened,
  setLookActiveFeature,
  setLookActiveCategory,
  setShopLastPageVisited,
  setShopPageLeaved,
  updateCanvasCount,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithShopFeatureVisualizeClick)
)
